import { createSelector } from 'reselect'
import { getPageData, getPageParams } from 'selectors/page'
import type { CollectionMetadata } from '../types'
export const getCollectionData = createSelector(
  getPageData,
  (data): CollectionMetadata => data.collectionData || {}
)
export const getCollectionIdUserCollection = createSelector(
  getCollectionData,
  (collection): number => collection.idUserCollection || 0
)
export const getCollectionId = createSelector([getPageParams], (params): number => {
  return params.collectionId || 0
})
export const getCollectionTypes = createSelector(
  getCollectionData,
  (collection): Array<string> => collection.collectionTypes || []
)
export const getCollectionPrintsView = createSelector(
  getCollectionData,
  (collection): boolean => collection.isPrintsView || false
)
export const getCollectionCount = createSelector(
  getCollectionData,
  (collection): number => collection.count || 0
)
export const getCreatedAt = createSelector(
  getCollectionData,
  (collection): number => collection.createdAt || 0
)
export const getIsCollectionPrivate = createSelector(
  getCollectionData,
  (collection): boolean => collection.isPrivate || false
)
export const getCollectionTitle = createSelector(
  getCollectionData,
  (collection): string => collection.title || ''
)
export const getCollectionDescription = createSelector(
  getCollectionData,
  (collection): string => collection.description || ''
)
export const getCollectionOwnerAvatar = createSelector(
  getCollectionData,
  (collection): string => collection.ownerAvatar || ''
)
export const getCollectionOwnerName = createSelector(
  getCollectionData,
  (collection): string => collection.ownerName || ''
)
export const getCollectionOwnerTitle = createSelector(
  getCollectionData,
  (collection): string => collection.ownerTitle || ''
)
export const getIdUserCollection = createSelector(
  getCollectionData,
  (collection): string => collection.idUserCollection || ''
)
export const getSlug = createSelector(getCollectionData, (data): string => data.slug || '')